// extracted by mini-css-extract-plugin
export default {"tabla":"stylesFacturacionHw_tabla__lINvw"};